import VentaProductoCodificado from "./VentaProductoCodificado";

export default VentaProductoCodificado;
